import React from 'react';
import styled from 'styled-components';
import { Row, Col, Card, Timeline, Button } from 'antd';
import { 
  UserOutlined, 
  MailOutlined, 
  GithubOutlined, 
  LinkedinOutlined,
  TwitterOutlined
} from '@ant-design/icons';
import ComingSoon from '../components/modules/ComingSoon';

const PageHeader = styled.div`
  background-color: #fff0f6;
  padding: 3rem 0;
  text-align: center;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #c41d7f;
`;

const PageDescription = styled.p`
  font-size: 1.1rem;
  max-width: 800px;
  margin: 0 auto;
  color: #666;
`;

const SectionContainer = styled.section`
  padding: 3rem 0;
`;

const SectionTitle = styled.h2`
  margin-bottom: 2rem;
  position: relative;
  
  &:after {
    content: '';
    display: block;
    width: 60px;
    height: 3px;
    background-color: #1890ff;
    margin-top: 0.5rem;
  }
`;

const ProfileCard = styled(Card)`
  margin-bottom: 2rem;
`;

const AvatarPlaceholder = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-color: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  color: #1890ff;
  margin: 0 auto 2rem;
`;

const ProfileName = styled.h3`
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 0.5rem;
`;

const ProfileTitle = styled.p`
  color: #666;
  text-align: center;
  margin-bottom: 2rem;
`;

const ProfileBio = styled.p`
  margin-bottom: 2rem;
  line-height: 1.8;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
  
  .ant-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const SkillsContainer = styled.div`
  margin-bottom: 2rem;
`;

const SkillCategory = styled.div`
  margin-bottom: 1.5rem;
  
  h4 {
    margin-bottom: 1rem;
    font-weight: 500;
  }
`;

const SkillTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  
  span {
    background-color: #f0f2f5;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    font-size: 0.9rem;
  }
`;

const About: React.FC = () => {
  const skills = {
    '编程语言': ['JavaScript', 'TypeScript', 'Python', 'Java', 'C++'],
    '前端技术': ['React', 'Vue', 'HTML5', 'CSS3', 'SCSS', 'Webpack'],
    'AI & 机器学习': ['TensorFlow', 'PyTorch', 'NLP', '计算机视觉', '强化学习'],
    '其他技能': ['Git', 'Docker', 'Linux', 'AWS', '数据可视化']
  };

  return (
    <>
      <PageHeader>
        <div className="container">
          <PageTitle>关于我</PageTitle>
          <PageDescription>
            了解我的背景、技能和专业经验
          </PageDescription>
        </div>
      </PageHeader>
      
      <SectionContainer>
        <div className="container">
          <Row gutter={[24, 24]}>
            <Col xs={24} md={8}>
              <ProfileCard>
                <AvatarPlaceholder>
                  <UserOutlined />
                </AvatarPlaceholder>
                <ProfileName>谦言万语</ProfileName>
                <ProfileTitle>AI 技术探索者 / 开发者</ProfileTitle>
                <SocialLinks>
                  <Button icon={<MailOutlined />} shape="circle" />
                  <Button icon={<GithubOutlined />} shape="circle" />
                  <Button icon={<LinkedinOutlined />} shape="circle" />
                  <Button icon={<TwitterOutlined />} shape="circle" />
                </SocialLinks>
              </ProfileCard>
              
              <Card title="联系方式">
                <ComingSoon 
                  title="联系信息完善中" 
                  description="联系方式即将更新..." 
                />
              </Card>
            </Col>
            
            <Col xs={24} md={16}>
              <Card title="个人简介" style={{ marginBottom: '2rem' }}>
                <ProfileBio>
                  欢迎来到我的个人主页！我是一名对AI技术充满热情的开发者，专注于AI编程、自然语言处理和多模态内容创作领域。
                </ProfileBio>
                <ProfileBio>
                  通过这个网站，我希望能够分享我在AI领域的探索经验、技术积累和创作成果，同时也整理了一些有价值的学习资源和知识链接，希望对您有所帮助。
                </ProfileBio>
                <ProfileBio>
                  目前网站内容正在持续更新中，敬请期待更多精彩内容！
                </ProfileBio>
              </Card>
              
              <Card title="专业技能" style={{ marginBottom: '2rem' }}>
                <SkillsContainer>
                  {Object.entries(skills).map(([category, skillList]) => (
                    <SkillCategory key={category}>
                      <h4>{category}</h4>
                      <SkillTags>
                        {skillList.map((skill) => (
                          <span key={skill}>{skill}</span>
                        ))}
                      </SkillTags>
                    </SkillCategory>
                  ))}
                </SkillsContainer>
              </Card>
              
              <Card title="教育与工作经历">
                <Timeline
                  items={[
                    {
                      children: '个人经历整理中，敬请期待...',
                    }
                  ]}
                />
              </Card>
            </Col>
          </Row>
        </div>
      </SectionContainer>
    </>
  );
};

export default About; 